
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/wideformatprintercosts/contact-us",
      function () {
        return require("private-next-pages/wideformatprintercosts/contact-us.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/wideformatprintercosts/contact-us"])
      });
    }
  